import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import * as moment from 'moment';
import * as _ from 'lodash';
import {SelectItem} from 'primeng/api';
import {SecurityService} from '../../../shared/services/security/security.service';
import {OrganizationPolicyDocument} from '../../../shared/types/organization/organization-policy-document-response';

@Component({
  selector: 'wsd-organization-constitution',
  templateUrl: './organization-constitution.component.html',
  styleUrls: ['./organization-constitution.component.css']
})
export class OrganizationConstitutionComponent implements OnInit {

  @Input()
  parentForm: UntypedFormGroup;

  documentsDisabled: boolean;

  years: SelectItem[] = [{label: null, value: null}].concat(
    _.range(1950, moment().year() + 1).map(year => ({label: year, value: year}))
  );

  constructor(private security: SecurityService) {
  }

  ngOnInit() {
    this.security.hasPermission('ORGANIZATION_CONSTITUTION_YEAR_UPDATE')
      .subscribe(hasPermission => {
        if (!hasPermission) {
          this.parentForm.get('constitutionApprovalYear').disable();
        }
      });
    this.security.hasPermission('ORGANIZATION_CONSTITUTION_RECEIVED_UPDATE')
      .subscribe(hasPermission => {
        if (!hasPermission) {
          this.parentForm.get('constitutionReceived').disable();
        }
      });
    this.security.hasPermission('ORGANIZATION_POLICY_INFORMATION_UPDATE')
      .subscribe(hasPermission => this.documentsDisabled = !hasPermission);
  }

  trackByIdentity = (index: number, item: OrganizationPolicyDocument) => item.id;

  get policyDocuments() { return this.parentForm.get('policyDocuments').value; }
}
